import SimpleAccordion from '../vendor/simple-accordion';

export default class Accordion {
  constructor(rootNode) {
    new SimpleAccordion(rootNode, {
      duration: 300,
      itemNumber: 100,
      elementClass: 'ac-item',
      questionClass: 'ac-item-title',
      answerClass: 'ac-item-content'
    });
  }
}
